import { render, staticRenderFns } from "./DragFileUpload.vue?vue&type=template&id=74ff969f&scoped=true&"
import script from "./DragFileUpload.vue?vue&type=script&lang=ts&"
export * from "./DragFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DragFileUpload.vue?vue&type=style&index=0&id=74ff969f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff969f",
  null
  
)

export default component.exports